import { RESET_FORM } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

export default () => companyGeneralActions[RESET_FORM]();
